import FactorBlock from "../FactorBlock.vue";
import { BaseFactorState } from "../../BaseFactorState";
import CheckedSelectionState from "./CheckedSelectionState";
import Factors from "../../Factors.vue";

/** Sélection des noeuds via une arborescence */
export default class NodesSelectionState extends BaseFactorState<FactorBlock> {
    public constructor() {
		super();
	}

    /** Sur l'entrée dans l'etat
     * @param args Paramètres optionnels
     */
    public Enter(args?: any): void {
        console.debug("NodeSelectionState - Benchmarking - Enter");
        this.context.Factors().StartSelection(args['selectionNode'], args['checkedNodeIds']);
    }
    
    /** Sur sortie de l'état sur application
     * @param args Paramètres optionnels
     */
    public Next(args?: any): void {
        console.debug("NodeSelectionState - Benchmarking - Next");
        
        this.context.FactorsVisible = false;
        this.context.UpdateCheckedNodes(args['selectionNode'], args['checkedNodeIds']);

        this.context.TransitionTo(new CheckedSelectionState());
    }

    /** Sur fermeture d'un etat */
    public Previous(args?: any): void {
        console.debug("NodeSelectionState - Benchmarking - Previous");
        this.context.FactorsVisible = false;

        this.context.TransitionTo(new CheckedSelectionState());
    }    
}